<on-loading *ngIf="isLoading"></on-loading>
<on-custom-fields
    *ngIf="!isLoading"
    (saveRequest)="saveFields()"
    [companyId]="companyId"
    [customFields]="companyFields"
></on-custom-fields>
